document.addEventListener('DOMContentLoaded',()=>{
  const money=cents=>new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:'USD'}).format(cents/100);

  document.querySelectorAll('[data-product-form]').forEach(form=>{
    const variantSelect=form.querySelector('[data-variant-select]');
    const scope=form.closest('.product-block')||form.parentElement;
    const productSection=form.closest('.product-page');
    const productDataEl=(scope&&scope.querySelector('[data-product-json]'))||(productSection&&productSection.parentElement?.querySelector('[data-product-json]'))||document.querySelector('[data-product-json]');
    const priceEl=scope?.querySelector('[data-product-price]');
    const buttonPrice=form.querySelector('[data-button-price]');
    const submit=form.querySelector('button[type="submit"]');
    const error=form.querySelector('[data-product-error]');
    const bundleForm=form.matches('[data-nula-bundle-form]');
    const galleryImage=scope?.querySelector('[data-product-gallery-image]');
    const mobileVariantPreview=form.querySelector('[data-mobile-variant-preview]');
    const packButtons=[...form.querySelectorAll('[data-pack-option]')];
    const secondEditGroup=form.querySelector('[data-second-edit-group]');
    const secondEditButtons=[...form.querySelectorAll('[data-second-edit-button]')];
    const secondEditLabel=form.querySelector('[data-second-edit-selected]');
    const packNote=form.querySelector('[data-pack-note]');
    const buttonLabel=form.querySelector('[data-button-label]');
    let packQty=1;
    let secondEditValue='';
    const quickBuyImage=scope?.querySelector('[data-quick-buy-image]');
    const fallbackImage=quickBuyImage?.dataset.fallbackImage||'';
    if(!variantSelect||!productDataEl) return;

    const variants=JSON.parse(productDataEl.textContent);
    const selected={};
    const initial=variants.find(v=>String(v.id)===String(variantSelect.value))||variants[0];
    if(initial) initial.options.forEach((v,i)=>selected[i+1]=v);
    const buttons=[...form.querySelectorAll('[data-option-button]')];

    function imageForSelection(match){
      // Prefer the exact selected variant's image. If size variants share the same
      // color image, this keeps the image tied to the Edit rather than the size.
      let imageVariant=match;
      const colorGroup=[...form.querySelectorAll('.edit-chip')];
      const selectedColorButton=colorGroup.find(btn=>selected[Number(btn.dataset.position)]===btn.dataset.value);
      if(selectedColorButton){
        const pos=Number(selectedColorButton.dataset.position);
        imageVariant=variants.find(v=>v.options[pos-1]===selectedColorButton.dataset.value && v.featured_image)||match;
      }
      const raw=imageVariant?.featured_image?.src||imageVariant?.featured_image?.url||fallbackImage;
      if(!raw) return '';
      return raw.startsWith('//') ? `https:${raw}` : raw;
    }

    function swapQuickBuyImage(match){
      if(!quickBuyImage&&!galleryImage&&!mobileVariantPreview) return;
      const src=imageForSelection(match);
      if(!src) return;
      if(quickBuyImage){
        const current=quickBuyImage.dataset.currentImage||''; if(current===src) return;
        quickBuyImage.classList.add('is-changing'); window.setTimeout(()=>{quickBuyImage.style.backgroundImage=`url("${src.replace(/"/g,'\\"')}")`;quickBuyImage.dataset.currentImage=src;quickBuyImage.classList.remove('is-changing')},120);
      } else if(galleryImage){ galleryImage.src=src; galleryImage.srcset=''; }
      if(mobileVariantPreview){
        mobileVariantPreview.classList.add('is-changing');
        window.setTimeout(()=>{mobileVariantPreview.src=src;mobileVariantPreview.srcset='';mobileVariantPreview.classList.remove('is-changing')},90);
      }
    }

    function refresh(){
      buttons.forEach(btn=>{
        const pos=Number(btn.dataset.position);
        btn.classList.toggle('is-selected',selected[pos]===btn.dataset.value);
        const label=form.querySelector(`[data-option-selected="${pos}"]`);
        if(label&&selected[pos]===btn.dataset.value) label.textContent=btn.dataset.display;
        const test={...selected,[pos]:btn.dataset.value};
        const possible=variants.some(v=>v.available&&v.options.every((val,i)=>!test[i+1]||test[i+1]===val));
        btn.disabled=!possible;
      });
      const match=variants.find(v=>v.options.every((val,i)=>selected[i+1]===val));
      if(match){
        variantSelect.value=match.id;
        if(priceEl) priceEl.textContent=money(match.price);
        if(buttonPrice) buttonPrice.textContent=money(match.price);
        if(submit) submit.disabled=!match.available;
        swapQuickBuyImage(match);
        error?.classList.remove('is-visible');
      }else if(submit){ submit.disabled=true; }
    }
    function refreshBundle(){
      if(!bundleForm) return;
      packButtons.forEach(btn=>btn.classList.toggle('is-selected',Number(btn.dataset.packOption)===packQty));
      if(secondEditGroup) secondEditGroup.hidden=packQty!==2;
      const colorPos=Number(secondEditGroup?.dataset.colorPosition||0);
      if(packQty===2&&colorPos&&!secondEditValue) secondEditValue=selected[colorPos]||secondEditButtons[0]?.dataset.value||'';
      secondEditButtons.forEach(btn=>{
        const test={...selected,[colorPos]:btn.dataset.value};
        const possible=variants.some(v=>v.available&&v.options.every((val,i)=>test[i+1]===val));
        btn.disabled=!possible;
        btn.classList.toggle('is-selected',btn.dataset.value===secondEditValue);
        if(btn.dataset.value===secondEditValue&&secondEditLabel) secondEditLabel.textContent=btn.dataset.display;
      });
      form.dataset.nulaPackQty=String(packQty);
      if(packQty===2){
        if(priceEl) priceEl.textContent='$69.99';
        if(buttonPrice) buttonPrice.textContent='$69.99';
        if(buttonLabel) buttonLabel.textContent='Add My 2-Pack';
        if(packNote) packNote.textContent='14 pairs. Mix any two color edits in the same size.';
        if(form.id==='nula-product-form'){
          const sp=document.querySelector('[data-sticky-price]');
          const st=document.querySelector('[data-sticky-title]');
          const sb=document.querySelector('[data-sticky-add]');
          if(sp)sp.textContent='$69.99';
          if(st)st.textContent='2 NULA Weeks';
          if(sb)sb.textContent='Add 2-pack';
        }
      }else{
        const match=variants.find(v=>String(v.id)===String(variantSelect.value));
        if(match&&priceEl) priceEl.textContent=money(match.price);
        if(match&&buttonPrice) buttonPrice.textContent=money(match.price);
        if(buttonLabel) buttonLabel.textContent='Add The NULA Week';
        if(packNote) packNote.textContent='Every NULA Week includes 7 pairs.';
        if(form.id==='nula-product-form'){
          const sp=document.querySelector('[data-sticky-price]');
          const st=document.querySelector('[data-sticky-title]');
          const sb=document.querySelector('[data-sticky-add]');
          if(sp&&match)sp.textContent=money(match.price);
          if(st)st.textContent='THE NULA WEEK™';
          if(sb)sb.textContent='Add to bag';
        }
      }
    }
    buttons.forEach(btn=>btn.addEventListener('click',()=>{selected[Number(btn.dataset.position)]=btn.dataset.value;refresh();refreshBundle()}));
    packButtons.forEach(btn=>btn.addEventListener('click',()=>{packQty=Number(btn.dataset.packOption)||1;refreshBundle()}));
    secondEditButtons.forEach(btn=>btn.addEventListener('click',()=>{secondEditValue=btn.dataset.value;refreshBundle()}));
    refresh();
    refreshBundle();
    form.addEventListener('submit',async e=>{
      if(!variantSelect.value){e.preventDefault();error?.classList.add('is-visible');return}
      if(!bundleForm||packQty!==2) return;
      e.preventDefault();
      const colorPos=Number(secondEditGroup?.dataset.colorPosition||0);
      const first=variants.find(v=>String(v.id)===String(variantSelect.value));
      const second=variants.find(v=>v.available&&v.options.every((val,i)=>i+1===colorPos?val===secondEditValue:val===selected[i+1]));
      if(!first||!second){error?.classList.add('is-visible');return}
      if(submit){submit.disabled=true;submit.setAttribute('aria-busy','true')}
      try{
        const root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
        const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:first.id,quantity:1,properties:{'_NULA Bundle':'2 NULA Weeks'}},{id:second.id,quantity:1,properties:{'_NULA Bundle':'2 NULA Weeks'}}]})});
        if(!response.ok) throw new Error('Unable to add bundle');
        window.location.href=root+'cart';
      }catch(err){
        error.textContent='We could not add that 2-pack. Please check your selections and try again.';
        error?.classList.add('is-visible');
        if(submit){submit.disabled=false;submit.removeAttribute('aria-busy')}
      }
    });
  });

  const productForm=document.querySelector('#nula-product-form');
  const sticky=document.querySelector('[data-sticky-add]');
  const stickyPrice=document.querySelector('[data-sticky-price]');
  if(productForm&&sticky){
    const select=productForm.querySelector('[data-variant-select]');
    const dataEl=productForm.closest('.product-page')?.parentElement?.querySelector('[data-product-json]')||document.querySelector('[data-product-json]');
    const submit=productForm.querySelector('button[type="submit"]');
    const stickyTitle=document.querySelector('[data-sticky-title]');
    const sync=()=>{
      if(!select||!dataEl)return;
      const vs=JSON.parse(dataEl.textContent);
      const v=vs.find(x=>String(x.id)===String(select.value));
      const packQty=Number(productForm.dataset.nulaPackQty||1);
      if(v){
        sticky.disabled=!v.available;
        if(packQty===2){
          if(stickyPrice)stickyPrice.textContent='$69.99';
          if(stickyTitle)stickyTitle.textContent='2 NULA Weeks';
          sticky.textContent='Add 2-pack';
        }else{
          if(stickyPrice)stickyPrice.textContent=money(v.price);
          if(stickyTitle)stickyTitle.textContent='THE NULA WEEK™';
          sticky.textContent='Add to bag';
        }
      }
    };
    productForm.addEventListener('click',()=>setTimeout(sync,0)); sync();
    sticky.addEventListener('click',()=>{if(productForm.requestSubmit)productForm.requestSubmit(submit);else submit?.click()});
  }

  document.querySelectorAll('a[href^="#"]').forEach(a=>a.addEventListener('click',e=>{const id=a.getAttribute('href');if(id.length>1){const t=document.querySelector(id);if(t){e.preventDefault();t.scrollIntoView({behavior:'smooth'})}}}));

  const sizeModal=document.querySelector('[data-size-guide-modal]');
  const openSizeGuide=()=>{if(!sizeModal)return;sizeModal.hidden=false;document.body.style.overflow='hidden';sizeModal.querySelector('[data-size-guide-close]')?.focus()};
  const closeSizeGuide=()=>{if(!sizeModal)return;sizeModal.hidden=true;document.body.style.overflow=''};
  document.querySelectorAll('[data-size-guide-open]').forEach(btn=>btn.addEventListener('click',openSizeGuide));
  document.querySelectorAll('[data-size-guide-close]').forEach(btn=>btn.addEventListener('click',closeSizeGuide));
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&sizeModal&&!sizeModal.hidden)closeSizeGuide()});
});
